module.exports = __webpack_public_path__ + "static/img/icon_signal.0e96b3b6.svg";